<template>
    <article>
        <section>
            <div class="checkout">
                <div class="checkout-header">
                    <h1>Please Review and Conf<span>i</span>rm Your Order</h1>
                    <div class="back-to-shop">
                        <div class="triangle">&#x25B2;</div>
                        <router-link to="/shop">Continue shopping</router-link>
                    </div>
                </div>
                <div class="checkout-form">
                    <form id="checkout">
                      <div class="flex">
                            <div class="left">
                               <contactInformation></contactInformation>
                                <addressFields></addressFields>
                                <payment ref="paymentsForm"></payment> 
                                <checkout-button id="mobile-button" @orderSubmitted="checkoutSubmitForm" class="mobile-show"></checkout-button>  
                            </div>
                            <div class="right">
                                <cart></cart>
                                <checkout-button id="desktop-button" @orderSubmitted="checkoutSubmitForm" class="mobile-hidden"></checkout-button>
                                <div class="banner">
                                    <p>10 % of your purchase is donated to<br /> Doctors Without Borders<br />Médecins Sans Frontières (MSF)</p>
                                    <a href="https://msf.org" target="_blank">
                                        <img src="https://queenslabcdn.blob.core.windows.net/odt/img/msr_white.png" width="420" alt="MSF SWEDEN">
                                    </a>
                                </div>
                            </div>
                        </div> 
                    </form>
                </div>
            </div>
        </section>
    </article>
</template>

<script>

import ContactInformation from '@/components/checkout/ContactInformation.vue'
import AddressFields from '@/components/checkout/AddressFields.vue'
import Payment from '@/components/checkout/Payment.vue'
import Cart from '@/components/checkout/Cart.vue'
import checkoutButton from '@/components/checkout/CheckoutButton.vue'

export default {
    name: "checkout",
    components: {
        ContactInformation,
        Payment,
        AddressFields,
        Cart,
        checkoutButton
    },
    methods: {
        checkoutSubmitForm() {
            this.$refs.paymentsForm.placeOrder(); 
        }   
    },
    mounted () {
      this.$store.dispatch('CHECKOUT/INITIAL_VALIDATION')
    }
}
</script>

<style lang="postcss" scoped>
section {
    max-width: var(--screen-wide);
}
.checkout {
    width: 100%;
    padding-top: 6%;
    margin-bottom: 6%;
}

a {
    color: inherit;
    text-decoration: none;
    font-family: 'Didot-Italic';
    font-size: 1.5em;
    margin-left: 1em;
}
.checkout-form {
    margin-top: 2.5em;
}
.flex {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    height: 100%;
}
.left{
    width: 30%;
    padding-left: 20%; 
}
 .right {
     margin-top: 4px;
    padding-left: 5%;
    width: 30%;
}

.back-to-shop {
    display: flex;
    padding-left: 10%;
}
.back-to-shop > * {
    font-size: 1em;
}
.triangle {
    transform: rotate(-90deg);
    height: 1.3em;
    font-size: 0.7em;
    margin-right: -0.5em;

}
 h1 {
    text-align: center;
    width: 100%;
    font-size: 1.6em;
    font-weight: normal;
    font-family:'Didot-Italic';
}

.photo {
  width: 100%;
  margin-bottom: 5%;
  margin-top: 10%;
}
.photo>img {
    border: 1px solid black;
    width: 50%;
    margin-left: 25%;
}
.photo>p {
    font-family: Didot-Italic;
    margin-left: 25%;
    line-height: 0%;
}
.banner {
    background: #777;
    border: 1px solid #777;
    padding: 1em 0;
    color: #fff;
    text-align: center;
    font-size: 1em;
    display: flex;
    flex-flow: row wrap;
    width: 100%;
}
.banner p {
    text-align: center;
    width: 100%;
    margin-bottom: 0.4em;
}
.banner a {
    margin: 0;
    padding: 0;
}
.banner img {
    display: block;
    width: 40%;
    height: 70px;
    object-fit: contain;
    padding: 0;
    margin: 0 auto;
}
.mobile-show {display: none;}

@media screen and (max-width: 768px) {
    h1 {
        max-width: 295px;
        margin: 0 auto;
    }
    .back-to-shop {
        display:none;
    }
    .left { order:2;}
    .right {order: 1; }
    .mobile-hidden {display:none;}
    .mobile-show {display: block;}
    .left, .right {
       width: 100%;
       padding: 5%;
       margin: 0;
    }

    .checkout {
        padding-top: 20%;
    }
   .back-to-shop {
        padding-left: 5%;
    }

    .photo {
        padding:0;
        margin: 10% 0% 10% 0%;
        width: 100%; 
    }
    .photo>img {
         width: auto;
        margin: 0;
        padding: 0;
        border: none;
    }
    .photo>p {
        text-align: center;
        padding-bottom: 5%;
        margin-left: 0;
    }

}




</style>